import React, { Fragment } from 'react';

import LoadingSpinner from './spinner';
import AppHeader from '../headers/appHeader';

const CombinedHeaderAndSpinner: React.FC = (): JSX.Element => {
    return (
        <Fragment>
            <AppHeader renderFullHeader={false} />
            <LoadingSpinner />
        </Fragment>
    );
};

export default CombinedHeaderAndSpinner;
